export enum GridTemplate {
  None = 'None',
  Sample = 'Sample',
  Order = 'Order'
}
